import {FC, useEffect, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {getFile, postFile} from '../../../services/files'
import {useToast} from '../../components/Toats'
import {LoadingSpan} from '../../components/Loadings/loadingSpan'
import catalogStyles from '../catalogo.module.css'

type Props = {
  imageKey?: string | null
  onChange: (key: string | null) => void
  label?: string
}

const CatalogImageUpload: FC<Props> = ({
  imageKey,
  onChange,
  label = 'Foto',
}) => {
  const {toggleToast} = useToast()
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let active = true

    const loadPreview = async () => {
      if (!imageKey) {
        if (active) setPreviewUrl(null)
        return
      }

      try {
        const response = await getFile(imageKey)
        if (active) setPreviewUrl(response?.url || null)
      } catch {
        if (active) setPreviewUrl(null)
      }
    }

    loadPreview()

    return () => {
      active = false
    }
  }, [imageKey])

  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return

    try {
      setLoading(true)
      const formData = new FormData()
      formData.append('file', file)
      const uploaded = await postFile(formData)
      const key = uploaded?.key || null
      onChange(key)
      if (uploaded?.url) {
        setPreviewUrl(uploaded.url)
      }
      toggleToast('Foto enviada com sucesso.', 'success')
    } catch (error) {
      console.log(error)
      toggleToast('Erro ao enviar a foto.', 'error')
    } finally {
      setLoading(false)
      event.target.value = ''
    }
  }

  return (
    <div className='fv-row mb-8'>
      <label className='d-flex align-items-center fs-5 fw-semibold mb-3'>
        <span>{label}</span>
      </label>

      <div className={catalogStyles.imageUploadBox}>
        {previewUrl ? (
          <img src={previewUrl} alt='' className={catalogStyles.imagePreviewLarge} />
        ) : (
          <div className={catalogStyles.imagePreviewFallback}>
            <KTSVG
              path='/media/icons/duotune/general/gen006.svg'
              className='svg-icon-3x'
            />
          </div>
        )}

        <div className='d-flex flex-column gap-2 flex-grow-1'>
          <span className='text-muted fs-7'>
            Envie uma imagem (JPG, PNG ou WEBP).
          </span>

          <div className='d-flex flex-wrap gap-2'>
            <label className={`btn btn-sm btn-light-primary mb-0 ${loading ? 'disabled' : ''}`}>
              {loading ? (
                <>
                  Enviando
                  <LoadingSpan style={{marginLeft: '0.5rem'}} />
                </>
              ) : (
                <>
                  <KTSVG path='/media/icons/duotune/files/fil018.svg' className='svg-icon-3' />
                  {previewUrl ? 'Trocar foto' : 'Adicionar foto'}
                </>
              )}
              <input
                type='file'
                accept='image/*'
                hidden
                disabled={loading}
                onChange={handleUpload}
              />
            </label>

            {imageKey && (
              <button
                type='button'
                className='btn btn-sm btn-light-danger'
                disabled={loading}
                onClick={() => {
                  onChange(null)
                  setPreviewUrl(null)
                }}
              >
                Remover
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export {CatalogImageUpload}
